import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next';

export interface IItemWithLanguageOptions {
    nameFi: string,
    nameSv: string,
    nameEn: string
}

interface IProps {
    toTranslate: IItemWithLanguageOptions
}

export function useTranslatedOptionFilter() {
    const { i18n } = useTranslation();

    const filterOptionFn = useCallback((input: string, option: any) => {
        const translatedOption = option.children as ReactElement<IProps>;

        if (translatedOption === undefined) {
            return false;
        }

        switch (i18n.language) {
            case "sv":
                return translatedOption.props.toTranslate.nameSv.toLowerCase().includes(input.toLowerCase());
            case "en":
                return translatedOption.props.toTranslate.nameEn.toLowerCase().includes(input.toLowerCase());
            default:
                return translatedOption.props.toTranslate.nameFi.toLowerCase().includes(input.toLowerCase());
        }
    }, [i18n.language]);

    return { filterOptionFn }
}

export default function TranslatedOption(props: IProps) {
    const { i18n } = useTranslation();

    const getTranslatedValue = useCallback(() => {
        switch (i18n.language) {
            case "sv":
                return props.toTranslate.nameSv;
            case "en":
                return props.toTranslate.nameEn;
            default:
                return props.toTranslate.nameFi;
        }
    }, [i18n.language]);

    return (
        <span>{getTranslatedValue()}</span>
    )
}